import { tabs } from '../../../../../../views/dashboard/company/CompanyDashboard';

export default {
  title: 'Armaturenbrett',
  tabs: {
    [tabs.general]: 'Allgemein',
    [tabs.overview]: 'Übersicht',
    [tabs.orders]: 'Bestellungen nach Quelle',
    [tabs.google]: 'Google',
    [tabs.customers]: 'Kunden',
    [tabs.order_conversion]: 'Order conversion',
    [tabs.mobile_app]: 'Mobile app',
  },
  date_range: {
    this_month: 'Diesen Monat',
    last_month: 'Letzten Monat',
    last_week: 'Letzte Woche',
    this_week: 'Diese Woche',
    this_year: 'Dieses Jahr',
    last_year: 'Letztes Jahr',
    today: 'Heute',
    yesterday: 'Gestern',
    all: 'Alle',
  },
  buttons: {
    view_key_info: 'Wichtige Informationen',
  },
  empty_franchise: {
    description: 'Diese Marke hat noch kein Restaurant. Wähle im Menü eine andere Marke, um ihre Zahlen zu sehen.',
  },
};
